import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Modal } from '../../../../core/services/modal';
import { ModalOptions } from '../../../utils/types';
import { ReferenceIdModal } from '../reference-id-modal/reference-id-modal';
import { Router } from '@angular/router';

@Component({
  selector: 'app-onboarding-modal',
  imports: [TranslatePipe, CommonModule],
  templateUrl: './onboarding-modal.html',
  styleUrl: './onboarding-modal.css'
})
export class OnboardingModal {
  @Input() options?: any;
  @Output() handleBtn = new EventEmitter<void>();

  constructor(private modalService: Modal, private router: Router) { }

  close(): void {
    this.modalService.close();
  }

  confirm(): void {
    // If parent provided a custom callback, call it
    if (this.options?.onConfirm && typeof this.options.onConfirm === 'function') {
      this.options.onConfirm();
    } else {
      // Otherwise, emit event to parent or close by default
      this.handleBtn.emit();
      this.close();
    }
  }

  startOnboarding(){
    this.close();
    this.router.navigate(['/onboarding']);
  }

  referenceIdModal() {
    const referenceIdModalOptions: ModalOptions = {
      backdropClosable: false,
      showCancelButton: false,
    };

    this.modalService.open(ReferenceIdModal, referenceIdModalOptions);
  }
}
